import { NavLink } from 'react-router-dom';
import { Images, LayoutGrid, Clapperboard } from 'lucide-react';

const MODES = [
  { to: '/before-after', label: 'Before / After', icon: Images, tid: 'bamode-ba' },
  { to: '/collage', label: 'Collage', icon: LayoutGrid, tid: 'bamode-collage' },
  { to: '/before-after-video', label: 'Video', icon: Clapperboard, tid: 'bamode-video' },
];

export default function BAModeNav() {
  return (
    <nav data-testid="ba-mode-nav" className="flex flex-wrap gap-2 mb-6">
      {MODES.map((m) => {
        const Icon = m.icon;
        return (
          <NavLink
            key={m.to}
            to={m.to}
            data-testid={m.tid}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-2.5 border font-display font-bold uppercase text-xs tracking-wider transition-colors ${
                isActive
                  ? 'bg-slate-900 text-white border-slate-800'
                  : 'bg-white text-slate-700 border-slate-300 hover:border-brand hover:text-brand'
              }`
            }
          >
            {({ isActive }) => (<><Icon size={15} className={isActive ? 'text-brand' : ''} /> {m.label}</>)}
          </NavLink>
        );
      })}
    </nav>
  );
}
